<div class="c-checkbox">
	<input [id]="name" type="checkbox" [formControl]="control" />
	<label [for]="name">
		<ng-content></ng-content>
	</label>
</div>
